<template>
  <section v-if="proBusinesses">
    <businesses-map
      :businesses="proBusinesses"
      :zoom="6"
      :custom-map-center="FRANCE_COORDS"
      hide-user-location-marker
      tall
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BusinessesMap from '../shared/map/BusinessesMap/BusinessesMap'

export default {
  components: {
    BusinessesMap,
  },
  computed: {
    ...mapState({
      proBusinesses: (state) => state.businessSearch.proBusinesses,
    }),
  },
  created() {
    this.FRANCE_COORDS = { lat: 47, lng: 2.21 }
  },
  mounted() {
    this.getProBusinesses()
  },
  methods: {
    ...mapActions({
      getProBusinesses: 'businessSearch/GET_PRO_BUSINESSES',
    }),
  },
}
</script>
<style lang="scss" scoped>
section {
  margin: auto;
  max-width: 800px;
}
</style>
